
import { Vue, Component, Ref } from 'vue-property-decorator';
import WorkbenchesService from '@/services/workbenches.service';
import lazyInject from '@/di';
import GMVAmountOrderDrawer from './GMVAmountOrderDrawer.vue';

@Component({
  components: {
    GMVAmountOrderDrawer,
  },
})
export default class GMVAmountShopDrawer extends Vue {
  visible = false;

  @lazyInject(WorkbenchesService)
  protected workbenchesService!: WorkbenchesService;

  @Ref('GMVAmountOrderDrawer')
  GMVAmountOrderDrawer!: GMVAmountOrderDrawer;

  filterForm: any = {
    shop_name: '',
    poi: '',
  };

  columns = [
    {
      title: '门店ID',
      dataIndex: 'shop_id',
      key: 'shop_id',
      align: 'center',
      width: 100,
    },
    {
      title: 'POI',
      dataIndex: 'poi',
      key: 'poi',
      align: 'center',
      width: 100,
    },
    {
      title: '门店名称',
      dataIndex: 'shop_name',
      key: 'shop_name',
      align: 'center',

      width: 100,
    },
    {
      title: ' GMV总和',
      dataIndex: 'gmv',
      key: 'gmv',
      align: 'center',
      width: 100,
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      scopedSlots: { customRender: 'action' },
      align: 'center',
      width: 100,
    },

  ];

  data = [];

  userId = '';


  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
    onChange: this.onChange,
  };

  onShowSizeChange(current: number, size: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = size;
    this.getShopList();
  }

  async onChange(current: number, size: number) {
    this.pagination.current = current;
    this.pagination.pageSize = size;
    this.getShopList();
  }

  handleShopDrawer(val: any) {
    this.GMVAmountOrderDrawer.init(val, this.userId);
  }

  init(val: any) {
    this.userId = val.user_id;
    this.getShopList();
    this.visible = true;
  }

  search() {
    this.pagination.current = 1;
    this.getShopList();
  }
  resetQuery() {
    this.filterForm = {
      shop_name: '',
      poi: '',
    };
    this.pagination.current = 1;
    this.getShopList();
  }

  async getShopList() {
    const data = {
      user_id: this.userId,
      page: this.pagination.current,
      pageSize: this.pagination.pageSize,
      month: this.$route.query.month,
      shop_name: this.filterForm.shop_name,
      poi: this.filterForm.poi,
    };
    const res = await this.workbenchesService.getAdGmvShopList(data);
    this.data = res.list;
    this.pagination.total = res.total;
  }
  close() {
    this.visible = false;
    this.data = [];
    this.pagination.current = 1;
    this.pagination.total = 0;
    this.filterForm = {
      shop_name: '',
      poi: '',
    };
  }
}
